import React from "react";
import {
  Paper,
  Grid,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  IconButton,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import VisibilityIcon from "@material-ui/icons/Visibility";

import { format } from "date-fns";
import StringUtils from "../../utils/stringUtils";

const CardDashboardUltimasConsultas = (props) => {
  const rows = props.relatorios;

  return (
    <Paper style={{ height: "19rem", overflow: "hidden" }}>
      <Grid container style={{ paddingTop: "0.35rem", overflow: "hidden" }}>
        <Grid item xs={12}>
          <Box paddingLeft="1rem" color="primaryDark.main">
            <Typography variant="h6">
              <b>Últimas pesquisas</b>
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Table size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <TableCell align="center">
                  <Box color="primaryDark.main">
                    <b>Tipo</b>
                  </Box>
                </TableCell>
                <TableCell align="center">
                  <Box color="primaryDark.main">
                    <b>Documento</b>
                  </Box>
                </TableCell>
                <TableCell align="center">
                  <Box color="primaryDark.main">
                    <b>Ações</b>
                  </Box>
                </TableCell>
                <TableCell align="center">
                  <Box color="primaryDark.main">
                    <b>Valor</b>
                  </Box>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <TableRow key={row.id}>
                  <TableCell align="center">
                    <Box fontSize={10}>
                      {/* {format(new Date(row.data_relatorio), "dd/MM/yyyy HH:mm")} */}
                      {row.nome_consulta}
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    <Box fontSize={10}>
                      {StringUtils.formatDocumento(row.documento)}
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    {row.status == 2 && (
                      <Tooltip title="Visualizar">
                        <IconButton
                          component={Link}
                          to={`/relatorios/${row.id}`}
                          aria-label="visualizar"
                          size="small"
                          height={11}
                          width={11}>
                          <VisibilityIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                  </TableCell>
                  <TableCell align="center">
                    <Box
                      fontSize={10}
                      color={row.status != 3 ? "green" : "red"}>
                      {StringUtils.formatBRL(row.valor)}
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default CardDashboardUltimasConsultas;
